module.exports = __webpack_public_path__ + "2c53516ae9e4e097d34f83a1f9bb36e9.svg";